@use '~/theme/theme' as *;

.form {
  display: flex;
  flex-grow: 1;
  height: 100%;
}

.formContent {
  width: 100%;
  min-height: 100%;
  flex: 1 0 0;
  justify-content: space-between;
}

.tableContainer {
  max-width: 100%;
  overflow-x: auto;
}

.controls {
  max-width: 50%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: spacing(2);
}

.entries {
  flex: 1 0 0;
}

.addRow {
  padding: spacing(2) 0;
}

.adjustmentColumn {
  width: 48px;
  white-space: pre-wrap;
}
